/** Traductions rapport paiements / caisse (FR / AR) */
export const paymentReportPageFr = {
  title: 'Rapport des Paiements',
  subtitle: 'Flux par méthode de paiement · même logique que le tableau manager',
  periodType: 'Type de période',
  today: "Aujourd'hui",
  lastDays: 'Derniers jours',
  customRange: 'Période personnalisée',
  numberOfDays: 'Nombre de jours',
  day1: '1 jour',
  days7: '7 jours',
  days30: '30 jours',
  days90: '90 jours',
  startDateLabel: 'Date de début',
  startDatePlaceholder: 'Choisir date de début',
  endDateLabel: 'Date de fin',
  endDatePlaceholder: 'Choisir date de fin',
  reportTypeLabel: 'Type de rapport',
  reportAll: 'Tous les soldes',
  reportMoneyIn: 'Argent entrant (totaux)',
  reportMoneyOut: 'Argent sortant',
  methodFilterLabel: 'Méthode filtrée',
  methodFilterClear: 'Toutes les méthodes',
  methodScopeNote: 'Les soldes ci-dessus couvrent toutes les méthodes.',
  outflowFilterLabel: 'Type de sortie',
  outflowAll: 'Toutes les sorties',
  outflowPurchase: 'Paiements fournisseurs',
  outflowExpense: 'Dépenses / charges',
  sortByLabel: 'Trier par',
  sortWorkerId: 'ID Employé',
  sortWorker: 'Nom Employé',
  sortDate: 'Date',
  sortAmount: 'Montant',
  sortMethod: 'Méthode',
  orderLabel: 'Ordre',
  orderAsc: 'Croissant',
  orderDesc: 'Décroissant',
  searchPlaceholder: 'Rechercher dans les sorties...',
  masterIncomeTitle: 'Entrées caisse (total)',
  masterIncomeHint:
    'Ventes encaissées + encaissements créances sur la période (même règle liquidité que le tableau manager). Détail ventes : page Ventes.',
  breakdownArrowLabel: 'Détail par canal',
  cashDetailTitle: 'Entrées — Espèces',
  electronicDetailTitle: 'Entrées — Électronique',
  cashIncomeLabel: 'Espèces encaissées (ventes + créances)',
  electronicIncomeLabel: 'Électronique encaissé (ventes + créances)',
  outflowSectionTitle: 'Sorties (total)',
  outflowSectionHint: 'Paiements fournisseurs et dépenses depuis la caisse.',
  goToSalesPage: 'Voir le tableau des ventes',
  transactionsTitle: 'Mouvements (sorties)',
  transactionsHint: 'Paiements fournisseurs et dépenses — sans les lignes de vente ni créances.',
  colFlow: 'Libellé',
  colCash: 'Espèces',
  colElectronic: 'Électronique',
  flowInSales: 'Entrées (ventes + créances)',
  methodBalanceTitle: 'Solde par méthode de paiement',
  methodBalanceFormula: 'Solde = Entrées (ventes + créances) − Fournisseurs − Charges',
  methodBalanceHint:
    'Seule la portion caisse compte. Entrées incluent les encaissements de créances. Hors caisse n’entre pas dans le solde.',
  colIncome: 'Entrées',
  colIncomeShort: 'Entrées',
  colSupplierPayments: 'Paiements fournisseurs',
  colSupplierShort: 'Fournisseurs',
  colExpensesOut: 'Dépenses / charges',
  colChargesShort: 'Charges',
  colAvailableBalance: 'Solde (caisse)',
  colSoldeShort: 'Solde',
  colExternalFinancing: 'Hors caisse',
  colExternalFinancingFull: 'Financement externe (ne réduit pas le solde)',
  colExternalShort: 'Externe',
  colOpeningCapitalFull: 'Capital démarrage utilisé (ne réduit pas le solde)',
  colOpeningCapitalShort: 'Capital',
  colMethodShort: 'Méthode',
  colValue: 'Valeur',
  noMethodBalance: 'Aucun mouvement sur la période',
  total: 'Total',
  colWorker: 'Effectué par',
  colDateTime: 'Date / Heure',
  colPaymentMethod: 'Méthode de paiement',
  colAmount: 'Montant',
  colType: 'Type',
  noTransactions: 'Aucune transaction',
  typePurchasePayment: 'Paiement fournisseur',
  typeExpense: 'Dépense',
  roleManager: 'Manager',
  roleCashier: 'Caissier',
  flowOutPayments: 'Paiements fournisseurs',
  flowOutExpenses: 'Dépenses',
  flowOutTotal: 'Total argent sortant',
  notSpecified: 'Non précisé',
  notSpecifiedAlt: 'Non spécifié',
  cashLabel: 'Espèces',
  electronicLabel: 'Électronique',
  colElectronicProvider: 'Fournisseur électronique',
  noElectronicData: 'Aucune donnée électronique',
  openingCapitalTitle: 'Capital démarrage (détail par méthode)',
  openingCapitalHint:
    'Payé depuis le capital démarrage — Espèces, Bankily, Sedad… N’entre pas dans le solde.',
  externalFinancingTitle: 'Financement externe (détail par méthode)',
  externalFinancingLabel: 'Méthode de paiement',
  externalFinancingHint:
    'Fremdkapital hors caisse — détail Espèces / Bankily / Sedad… N’entre pas dans le solde. ≠ Capital démarrage.',
  exportTitle: 'Rapport de Caisse Amélioré',
  exportTitleAr: 'تقرير الصندوق المحسن',
  exportTotalRevenue: 'Total Revenus',
  exportTotalIn: 'Total entrant',
  exportTotalOut: 'Total sortie',
  exportCurrentBalance: 'Solde disponible',
  exportOpeningCapital: 'Capital démarrage',
  exportExternalFinancing: 'Financement externe'
};

export const paymentReportPageAr = {
  title: 'تقرير المدفوعات',
  subtitle: 'التدفقات حسب طريقة الدفع · نفس منطق لوحة المدير',
  periodType: 'نوع الفترة',
  today: 'اليوم',
  lastDays: 'آخر أيام',
  customRange: 'فترة مخصصة',
  numberOfDays: 'عدد الأيام',
  day1: '1 يوم',
  days7: '7 أيام',
  days30: '30 يوم',
  days90: '90 يوم',
  startDateLabel: 'من تاريخ',
  startDatePlaceholder: 'اختر تاريخ البداية',
  endDateLabel: 'إلى تاريخ',
  endDatePlaceholder: 'اختر تاريخ النهاية',
  reportTypeLabel: 'نوع التقرير',
  reportAll: 'كل الأرصدة',
  reportMoneyIn: 'الأموال الواردة (إجماليات)',
  reportMoneyOut: 'الأموال الصادرة',
  methodFilterLabel: 'طريقة مُرشَّحة',
  methodFilterClear: 'كل الطرق',
  methodScopeNote: 'الأرصدة أعلاه تشمل كل الطرق.',
  outflowFilterLabel: 'نوع الصادر',
  outflowAll: 'كل الصادر',
  outflowPurchase: 'مدفوعات الموردين',
  outflowExpense: 'المصروفات / الأعباء',
  sortByLabel: 'ترتيب حسب',
  sortWorkerId: 'معرف الموظف',
  sortWorker: 'اسم الموظف',
  sortDate: 'التاريخ',
  sortAmount: 'المبلغ',
  sortMethod: 'طريقة الدفع',
  orderLabel: 'الترتيب',
  orderAsc: 'تصاعدي',
  orderDesc: 'تنازلي',
  searchPlaceholder: 'البحث في الصادر...',
  masterIncomeTitle: 'الوارد للصندوق (الإجمالي)',
  masterIncomeHint:
    'المبيعات المحصلة + تحصيل ديون العملاء في الفترة (نفس قاعدة السيولة كلوحة المدير). تفاصيل المبيعات: صفحة المبيعات.',
  breakdownArrowLabel: 'التفصيل حسب القناة',
  cashDetailTitle: 'الوارد — نقد',
  electronicDetailTitle: 'الوارد — إلكتروني',
  cashIncomeLabel: 'نقد محصّل (مبيعات + ديون)',
  electronicIncomeLabel: 'إلكتروني محصّل (مبيعات + ديون)',
  outflowSectionTitle: 'الصادر (الإجمالي)',
  outflowSectionHint: 'مدفوعات الموردين والمصروفات من الصندوق.',
  goToSalesPage: 'عرض جدول المبيعات',
  transactionsTitle: 'الحركات (الصادر)',
  transactionsHint: 'مدفوعات الموردين والمصروفات — بدون أسطر البيع أو تحصيل الديون.',
  colFlow: 'البند',
  colCash: 'نقد',
  colElectronic: 'إلكتروني',
  flowInSales: 'وارد (مبيعات + تحصيل ديون)',
  methodBalanceTitle: 'الرصيد حسب طريقة الدفع',
  methodBalanceFormula: 'الرصيد = الوارد (مبيعات + تحصيل) − الموردين − المصروفات',
  methodBalanceHint:
    'يُحسب فقط جزء الصندوق. الوارد يشمل تحصيل ديون العملاء. خارج الصندوق لا يخصم من الرصيد.',
  colIncome: 'وارد',
  colIncomeShort: 'وارد',
  colSupplierPayments: 'مدفوعات الموردين',
  colSupplierShort: 'موردين',
  colExpensesOut: 'مصروفات / أعباء',
  colChargesShort: 'مصروفات',
  colAvailableBalance: 'رصيد الصندوق',
  colSoldeShort: 'الرصيد',
  colExternalFinancing: 'خارج الصندوق',
  colExternalFinancingFull: 'تمويل خارجي (لا يخصم من الرصيد)',
  colExternalShort: 'خارجي',
  colOpeningCapitalFull: 'رأس مال البدء المستخدم (لا يخصم من الرصيد)',
  colOpeningCapitalShort: 'رأس المال',
  colMethodShort: 'الوسيلة',
  colValue: 'القيمة',
  noMethodBalance: 'لا حركة في هذه الفترة',
  total: 'الإجمالي',
  colWorker: 'أُنفِذ بواسطة',
  colDateTime: 'التاريخ / الوقت',
  colPaymentMethod: 'طريقة الدفع',
  colAmount: 'المبلغ',
  colType: 'النوع',
  noTransactions: 'لا توجد معاملات',
  typePurchasePayment: 'دفع مورد',
  typeExpense: 'مصروف',
  roleManager: 'مدير',
  roleCashier: 'أمين صندوق',
  flowOutPayments: 'مدفوعات الموردين',
  flowOutExpenses: 'المصروفات',
  flowOutTotal: 'إجمالي الأموال الصادرة',
  notSpecified: 'غير محدد',
  notSpecifiedAlt: 'غير محدد',
  cashLabel: 'نقداً',
  electronicLabel: 'إلكتروني',
  colElectronicProvider: 'المزود الإلكتروني',
  noElectronicData: 'لا توجد بيانات إلكترونية',
  openingCapitalTitle: 'رأس مال البدء (تفصيل حسب الطريقة)',
  openingCapitalHint:
    'مدفوع من رأس مال البدء — نقد، Bankily، Sedad… لا يدخل في الرصيد.',
  externalFinancingTitle: 'تمويل خارجي (تفصيل حسب الطريقة)',
  externalFinancingLabel: 'طريقة الدفع',
  externalFinancingHint:
    'تمويل خارج الصندوق — تفصيل نقد / Bankily / Sedad… لا يدخل في الرصيد. ≠ رأس مال البدء.',
  exportTitle: 'تقرير الصندوق المحسن',
  exportTitleAr: 'تقرير الصندوق المحسن',
  exportTotalRevenue: 'إجمالي الإيرادات',
  exportTotalIn: 'إجمالي الوارد',
  exportTotalOut: 'إجمالي الصادر',
  exportCurrentBalance: 'الرصيد المتاح',
  exportOpeningCapital: 'رأس مال البدء',
  exportExternalFinancing: 'تمويل خارجي'
};
